import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

type ComputeOptimizationsDto = ClientInferResponseBody<typeof contract.optimizations.compute>;

export type OptimizationDto = ComputeOptimizationsDto["optimizations"][number];

export const computeOptimizations = async (quoteRequestId: string): Promise<OptimizationDto[]> => {
  const response = await api.optimizations.compute.mutation({
    body: { quoteRequestId },
  });

  if (response.status !== 200) {
    throw new ApiError("Error computing optimizations", response.status, response.body);
  }

  return response.body.optimizations;
};
